import Swiper, { Autoplay, EffectFade, Pagination } from "swiper";


document.addEventListener('DOMContentLoaded', () => {
  const banner = document.querySelector('.banner-main')
  const preloader = document.querySelector('.preloader')
  if (banner) {
    let bannerSlides = banner.querySelectorAll('.banner-slide')

    const updateSlide = () => {
      bannerSlides = banner.querySelectorAll('.banner-slide')
    }

    const createSlider = () => {
      const bannerSwiper = new Swiper('.banner-main__slider', {
        modules: [Pagination, EffectFade, Autoplay],
        spaceBetween: 2,
        effect: "fade",
        speed: 1000,
        parallax: true,
        loop: false,
        pagination: {
          el: '.banner-main__pagination-list',
          bulletClass: 'pagination__item banner-main__pagination',
          bulletActiveClass: 'pagination__item--active',
          clickable: true
        },
        breakpoints: {
          780: {
            allowTouchMove: false
          },
          0: {
            allowTouchMove: true
          }
        }
      })

      banner.querySelector('.pagination__item--active')?.classList.remove('pagination__item--active')
      setTimeout(() => {
        banner.querySelector('.banner-main__pagination')?.classList.add('pagination__item--active')
      })

      let throttle = false

      let slideChange = setTimeout(() => {
        bannerSwiper.slideNext()
      }, 10000)

      const paginations = banner.querySelectorAll('.banner-main__pagination')
      bannerSwiper.slides.forEach((slide, index) => {
        if(slide.querySelector('video')) {
          paginations[index]?.classList.add('pagination__item--long')
        }
      })
      bannerSwiper.on('slideChange', (e) => {
        updateSlide()
        clearTimeout(slideChange)
        if (throttle) {
          slideChange = setTimeout(() => {
            throttle = false
            bannerSwiper.slideNext()
          }, 30000)
        } else {
          slideChange = setTimeout(() => {
            bannerSwiper.slideNext()
          }, 10000)
        }

        let bannerVideo = bannerSlides[bannerSwiper.realIndex].querySelectorAll('video')
        if (bannerVideo.length) {
          bannerVideo.forEach(video => {
            video.currentTime = 0
          })
        }
      })
      bannerSwiper.on('sliderMove', () => {
        throttle = true
      })
      paginations?.forEach(item => {
        item.addEventListener('click', () => {
          throttle = true
        })
      })
    }

    const mutationObserver = new MutationObserver(mutations => {
      mutations.forEach(() => {
        if(preloader.classList.contains('preloader--hidden')) {
          setTimeout(() => {
            createSlider()
          }, 310)
        }
      });
    });
    mutationObserver.observe(preloader, {
      attributes: true,
    })
  }
})
